import { RootState } from '@algoan/dashboard/store/store';
import { AsyncStatus, Transaction } from '@algoan/dashboard/model';
import { TransactionErrorMessages } from '@algoan/dashboard/store/slice';
import { createSelector } from '@reduxjs/toolkit';

export const transactionsFetchingStatusSelector = (state: RootState): AsyncStatus =>
  state.transaction.transactionsFetchingStatus;

export const isTransactionsLoadingSelector: (state: RootState) => boolean = createSelector(
  transactionsFetchingStatusSelector,
  (transactionsFetchingStatus: AsyncStatus): boolean =>
    transactionsFetchingStatus === AsyncStatus.IDLE || transactionsFetchingStatus === AsyncStatus.PENDING,
);

export const transactionsErrorSelector = (state: RootState): TransactionErrorMessages | undefined =>
  state.transaction.transactionsError;

export const transactionsSelector = (state: RootState): Transaction[] =>
  state.transaction.transactions.filter((transaction) => transaction.isNonAnalysed !== true);
